module.exports = __webpack_public_path__ + "0d5e2ecbdeae19519a40b01e6543939c.png";